import { Box } from '@factorialco/deprecated-design-system'
import { Dropdown } from '@factorialco/factorial-one-react/dist/experimental'
import { Delete, Folders } from '@factorialco/factorial-one-react/icons/app'

import i18n from 'modules/core/lib/i18n'

const QuestionSidebarDropdown = ({
  isVisible,
  onDelete,
  onDuplicate,
}: {
  isVisible: boolean
  onDelete: () => void
  onDuplicate: () => void
}) => {
  return (
    <Box style={{ visibility: isVisible ? 'visible' : 'hidden' }}>
      <Dropdown
        items={[
          {
            label: i18n.t('forms.modals.actions.duplicate'),
            icon: Folders,
            onClick: onDuplicate,
          },
          {
            label: i18n.t('forms.modals.actions.delete'),
            icon: Delete,
            onClick: onDelete,
          },
        ]}
      />
    </Box>
  )
}

export default QuestionSidebarDropdown
